import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.isLoggedIn()) {
      return true;
    }
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  // public isLoggedIn(): boolean {
  //   if (sessionStorage.getItem('uuid')) {
  //     return true;
  //   }
  //   return false;
  // }

  public isLoggedIn(): boolean {
    if (sessionStorage.getItem('isLoggedIn') === 'true') {
      return true;
    }
    return false;
  }


}
